<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="border-none py-0 mb-0 px-1">
      <b-alert :show="warning" variant="primary" class="mt-2">
        <b-row align-v="center" no-gutters
          ><b-col cols="auto mr-3">
            <i class="fa fa-info-circle fa-2x"></i
          ></b-col>
          <b-col>
            <b-col v-if="anonymiser.selected[0]"
              >The lead name selected will be
              {{ anonymiser.selected[0].surname }}/{{
                anonymiser.selected[0].firstname
              }}. Other names will be alised. Click "Save It" to confirm.</b-col
            >

            <b-col v-else> Please select a lead name. </b-col>
          </b-col></b-row
        >
      </b-alert>
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col>
            <i :class="anonymiser.icon + ' fa-2x mr-1 text-primary'"></i>
            <span v-if="anonymiser.selected[0]" class="h4 ml-1">
              {{ anonymiser.selected[0].surname }}/{{
                anonymiser.selected[0].firstname
              }}
              <!-- {{ this.same.selected[0].surname }}/{{ this.same.selected[0].firstname }} -->
            </span>
          </b-col>
        </b-row>
      </b-card-header>

      <d-table
        classdivtable="availtable datatable"
        refid="anonymiser"
        :icon="anonymiser.icon"
        :busy="anonymiser.busy"
        :toolbarlibrary="anonymiser.toolbarlibrary"
        :tools="anonymiser.tools"
        :badges="anonymiser.badges"
        :fields="anonymiser.fields"
        :items="anonymiser.items"
        :showtoolbar="false"
        :showpages="false"
        :showrowcount="false"
        :selectmode="'single'"
        @load="load"
        @click="anonymiser_click"
        @changed="anonymiser_click('save', $event)"
        @select="anonymiser_select"
      >
      </d-table>

      <b-card-footer class="nopadding mt-2">
        <b-row no-gutters>
          <b-col cols="auto" class="text-left mr-3">
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
          <b-col class="text-left my-auto">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="$emit('discard')">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>

    </b-card>
  </b-overlay>
</template>
  
  <script>
import gql from "graphql-tag";

export default {
  name: "AnonymiserSame",
  data() {
    return {
      busy: false,
      warning: true,
      anonymiser: {
        title: "Anonymiser",
        icon: "fa fa-user-secret",
        debounce: 500,
        busy: false,
        page: 1,
        tools: "",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },

          {
            key: "key",
            label: "Anonymised ID",
            sortable: true,
            class: "text-left",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "surname",
            label: "Surname",
            sortable: true,
          },
          {
            key: "firstname",
            label: "First Name",
            sortable: true,
          },
          {
            key: "ref",
            label: "Profile ID",
            sortable: true,
          },
          {
            key: "category",
            label: "Category",
            sortable: true,
          },

          // {
          //   key: "actions",
          //   label: "Actions",
          //   class: "actions w-100px",
          // },
        ],
        badges: [],
        items: [],
        selected: [],
        denied: [],
      },
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    readonly() {
      return false;
    },
  },
  methods: {
    async load() {
      this.anonymiser.busy = true;
      // COPY THE SELECTION TO ITEMS
      this.anonymiser.items = [...this.selection];
      this.anonymiser.busy = false;
    },

    async saveit() {

      let rows = [];
      for (var i = 0; i < this.anonymiser.items.length; i++) {
        let item = this.anonymiser.items[i];
        if (item.id != this.anonymiser.selected[0].id) {
          rows.push(item);
        }
      }
      rows.unshift(this.anonymiser.selected[0]);

      // let removeIndex = this.anonymiser.items
      //   .map((item) => item.id)
      //   .indexOf(this.selection[0].id);
      // this.anonymiser.items.splice(removeIndex, 1);
      // let rows = [...this.anonymiser.selected];

      rows.forEach(function (v) {
        delete v.rows;
        delete v.index;
      });

      let variables = {
        rows,
      };
      console.log("variables", variables);

      this.anonymiser.busy = true;

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation anonymiser_same($rows: [anonymiser_input]) {
              anonymiser_same(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.warning = false;
      this.anonymiser.items = [];

      this.anonymiser.busy = false;

      this.discard()
    },

    async anonymiser_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.load();
          break;
        case "add":
      }
    },
    async anonymiser_select(ss, tools) {

      let state = this.anonymiser;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
  },
};
</script>
  
<style>
</style>